import { render, staticRenderFns } from "./fifthIndex.vue?vue&type=template&id=68cd5cb2&scoped=true&"
import script from "./fifthIndex.vue?vue&type=script&lang=js&"
export * from "./fifthIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cd5cb2",
  null
  
)

export default component.exports